import timedFetch from 'middleware/timedFetch';
import type { ReviewSummarizationResponse } from 'types/reviewSummarization';

export const getReviewSummarization = ({
  reviewSummaryUrl,
  productId,
  controller,
  fetcher = timedFetch('getReviewSummarization')
}: {
  reviewSummaryUrl: string;
  productId: string;
  controller: AbortController;
  fetcher?: Function;
}): Promise<Response<ReviewSummarizationResponse>> => {
  const opts = {
    signal: controller.signal
  };
  return fetcher(getReviewSummarizationUrl({ reviewSummaryUrl, productId }), opts);
};

export const getReviewSummarizationUrl = ({ reviewSummaryUrl, productId }: { reviewSummaryUrl: string; productId: string }) =>
  `${reviewSummaryUrl}/${productId}.json`;
